import type ApplicationInstance from "@ember/application/instance";
import { getOwner } from "@ember/owner";
import Service, { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";

export default class ParogService extends Service {
  @tracked _wiser = false;
  @service store;

  ENV: Environment;

  constructor(owner: ApplicationInstance) {
    super(owner);

    this.ENV = (getOwner(this) as ApplicationInstance).resolveRegistration(
      "config:environment"
    ) as Environment;

    this._wiser = false;
  }

  /**
   * Version of the app, automatically updated when releasing
   */
  get version(): string {
    return this.ENV.APP.version as string;
  }

  get conf() {
    return this.ENV.parog;
  }

  get wiser() {
    return this._wiser;
  }

  set wiser(flag: boolean) {
    this._wiser = flag;
  }

  /**
   * Called when a medic wants to display a completed form from the timeline.
   * If you don't want to display the collected data in the form used during the initial completion, return another one.
   * @param formId initially used to complete the form
   * @returns The formId used to display the form
   */
  formIdToDisplayFromTimeline(formId: string) {
    return formId;
  }

  /**
   * Called when a patient is created.
   */

  patientCreated(/*patient*/) {}

  /**
   * Called when a medic wants to edit a form. The form from which the medic switches to edit mode
   * is not always the one used for displaying the form (related to `formIdToDisplayFromTimeline`).
   * @param formId used to display the form
   * @returns The formId wanted for the edition
   */
  formIdForEdition(formId: string) {
    return formId;
  }

  /**
   * Hook called when a form is saved.
   */

  formSaved(/*{ form, payload, context }*/) {}
}

declare module "@ember/service" {
  interface Registry {
    parog: ParogService;
  }
}
